import { FC, useState } from "react";
import useI18n from "../../../../../hooks/useTranslations";
import Button from "../../../../ui/Button";
import ModalDialog from "../../../../ui/ModalDialog";
import FasteningChoiceForm from "./FasteningChoiceForm";

interface CreateFasteningChoiceModalDialogButtonProps {
  systemId: string;
}

const CreateFasteningChoiceModalDialogButton: FC<CreateFasteningChoiceModalDialogButtonProps> = ({ systemId }) => {
  const i18n = useI18n();
  const [showNewItemDialog, setShowNewItemDialog] = useState(false);

  return (
    <>
      <Button buttonProps={{ onClick: () => setShowNewItemDialog(true) }}>{i18n.translation.common.createNew}</Button>
      {showNewItemDialog && (
        <ModalDialog onClose={() => setShowNewItemDialog(false)} title={i18n.translation.fasteningChoices.createNew}>
          <FasteningChoiceForm onClose={() => setShowNewItemDialog(false)} systemId={systemId} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateFasteningChoiceModalDialogButton;
